/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineSharedClassModulesQueryResponse,
  GetApiV1ClassroomdisciplineSharedClassModulesQueryParams,
  GetApiV1ClassroomdisciplineSharedClassModules401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassModules.ts";

function getGetApiV1ClassroomdisciplineSharedClassModulesUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/shared/class-modules` as const,
  };
  return res;
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de módulos de aula (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/class-modules}
 */
export async function getApiV1ClassroomdisciplineSharedClassModules(
  params?: GetApiV1ClassroomdisciplineSharedClassModulesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineSharedClassModulesQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassModules401>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineSharedClassModulesUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
